import { Avatar, Box, Card, Grid } from '@mui/material';

import React from 'react';
import { SimTypography } from 'components/SimTypography';
import { useTheme } from '@mui/material/styles';

export const WhyChooseUsCard = ({ item, idx }) => {
	const theme = useTheme();

	return (
		<Grid item xs={12} sm={6} md={4}>
			<Box
				component={Card}
				padding={4}
				width={1}
				height={1}
				data-aos={'fade-up'}
				data-aos-delay={idx * 100}
				data-aos-offset={100}
				data-aos-duration={600}
				bgcolor={theme.palette.background.transparentDefault}>
				<Box display={'flex'} flexDirection={'column'}>
					<Box
						component={Avatar}
						width={50}
						height={50}
						marginBottom={2}
						bgcolor={theme.palette.primary.main}
						color={theme.palette.background.default}>
						{item.icon}
					</Box>
					<SimTypography
						variant={'h5'}
						gutterBottom
						sx={{
							fontWeight: 600
						}}>
						{item.title}
					</SimTypography>
					<SimTypography color='text.secondary'>{item.subtitle}</SimTypography>

					{item.hasList ? (
						<Box>
							{item.list.map(listItem => (
								<Box display='flex' flexDirection='row' key={listItem}>
									<SimTypography color='text.secondary' paddingX={1}>
										&#x2022;
									</SimTypography>
									<SimTypography color='text.secondary'>{listItem}</SimTypography>
								</Box>
							))}
						</Box>
					) : null}
				</Box>
			</Box>
		</Grid>
	);
};
